<template>
  <div
    class="pure-item"
    :data-color="data"
    :style="{
      backgroundColor: data
    }"
  />
</template>

<script>
export default {
  props: {
    data: String
  }
};
</script>

<style scoped>
.pure-item{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
